import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_2 = {
  title:
    "Simplify boundary definition \nwith the Infosys platform's \npolygon tool.",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_318"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_315"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_02_map_1.png",
          imageStyle: { position: "absolute", bottom: "348px", right: "103px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_02_map_2.png",
          imageStyle: { position: "absolute", bottom: "195px", right: "90px" },
        },
      ]}
      pageNumber={"ENG_316"}
    />
  ),
};
